import { render, staticRenderFns } from "./DialogEscolhaAmbienteHierarchy.vue?vue&type=template&id=75d881af&scoped=true&"
import script from "./DialogEscolhaAmbienteHierarchy.vue?vue&type=script&lang=js&"
export * from "./DialogEscolhaAmbienteHierarchy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d881af",
  null
  
)

export default component.exports